import { useMemo } from 'react';
import type { Country } from '@Types/country';

interface UseUBOCountriesParams {
  countries: Country[];
}

interface UseUBOCountriesReturn {
  countriesList: { title: string; value: string }[];
  nonUsCountriesList: { title: string; value: string }[];
  phoneCountryCodes: string[];
}

export const useUBOCountries = ({ countries }: UseUBOCountriesParams): UseUBOCountriesReturn => {
  const countriesList = useMemo(
    () =>
      countries.map((country) => ({
        title: country.name,
        value: country.code,
      })),
    [countries]
  );

  const nonUsCountriesList = useMemo(
    () => countriesList.filter((country) => country.value !== 'US'),
    [countriesList]
  );

  const phoneCountryCodes = useMemo(() => countries.map((country) => country.code), [countries]);

  return {
    countriesList,
    nonUsCountriesList,
    phoneCountryCodes,
  };
};
